import { mainServer } from "./Api";

export const fetchData = async ({
  url,
  params = {},
  config = {},
  method = "get",
}) => {
  const httpMethod = method.toLowerCase();

  switch (httpMethod) {
    case "get":
      return (await mainServer.get(url, { params, ...config })).data;

    case "delete":
      return (await mainServer.delete(url, { data: params, ...config })).data;

    case "put":
      return (await mainServer.put(url, params, { ...config })).data;

    case "patch":
      return (await mainServer.patch(url, params, { ...config })).data;

    case "post":
    default:
      return (await mainServer.post(url, params, { ...config })).data;
  }
};
export const mutateData = async ({ url, data, method = "post", config }) => {
  const httpMethod = method.toLowerCase();

  return (
    await mainServer({
      url,
      method: httpMethod,
      data,
      ...config,
    })
  ).data;
};
